export default "__VITE_ASSET__D0q8NWlQ__"